import React, { Component } from 'react'
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth } from './Firebase'

export default class UserNavbar extends Component {
    constructor(props) {
      super(props)
      this.state = {
         User : '',
      }
    }
    componentDidMount(){
        onAuthStateChanged(firebaseAuth, (user) => {
          if(user){
            const number = user.phoneNumber;
            this.setState({
                User : number
            })
          }
        });          
    }

  render() {
    return (
      <div>
        {this.state.User === ''? <></> : <div className='UserNavbar'>
            <span>Hello! User ({this.state.User})</span>
        </div>}
      </div>
    )
  }
}
